<template>
  <a-breadcrumb class="app-breadcrumb" separator="/" v-if="levelList[0].path !== '/testManage/realtimeMonitor'">
    <a-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
      <!-- <template v-if="item.redirect === 'noRedirect' || index === levelList.length - 1">
          <span class="no-redirect text">{{ item.meta.title }}</span>
        </template> -->

      <template v-if="index === levelList.length - 1">

        <MyIcon :type="item.meta.icon" />

        <span class="no-redirect text">{{ item.meta.title }}</span>
      </template>
      <template v-else>
        <span class="no-redirect text" style="color:#768792">{{ item.meta.title }}</span>
      </template>
      <!-- <template v-else>
          <a @click.prevent="handleLink(item)">123{{ item.meta.title }}</a>
        </template> -->
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const levelList = ref([]);

function getBreadcrumb() {
  // only show routes with meta.title
  let matched = route.matched.filter(item => item.meta && item.meta.title);
  const first = matched[0];
  // 判断是否为首页
  if (!isDashboard(first)) {
    matched = [{ path: '/index', meta: { title: '首页' } }].concat(matched);
  }
  console.log(route);
  console.log(matched, '111111');
  let filterList = ['参数要求管理', '内场项目', '外场项目', '测试模板管理', '人员档案管理', '测试任务发起', '进度监控', '任务详单',]
  let lastChild = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false).pop()
  if (filterList.indexOf(lastChild.meta.title) > -1) {
    levelList.value = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false).splice(-2)
  } else {
    levelList.value = [matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false).pop()];
  }


  // console.log(levelList.value, 'levelList');
}

function isDashboard(route) {
  const name = route && route.name;
  if (!name) {
    return false;
  }
  return name.trim() === 'Index';
}

function handleLink(item) {
  const { redirect, path } = item;
  if (redirect) {
    router.push(redirect);
    return;
  }
  router.push(path);
}

watchEffect(() => {
  // if you go to the redirect page, do not update the breadcrumbs
  if (route.path.startsWith('/redirect/')) {
    return;
  }
  getBreadcrumb();
});

getBreadcrumb();
</script>

<style lang='scss' scoped>
.app-breadcrumb {
  font-size: 18px;
  padding: 25px 20px 0 20px;
  margin: 0 25px;
  background: #fff;

  .no-redirect {
    color: #1D2129;
    font-size: 20px;
    font-weight: 600;
    cursor: text;
  }

  .anticon {
    font-size: 27px;
    margin-right: 10px;
  }
}

::v-deep .ant-breadcrumb-separator {
  font-size: 20px;
  color: #657681;
}

::v-deep .ant-breadcrumb-link {
  display: flex;
  align-items: center;
}
</style>